import { Box, Stack, Typography } from '@mui/material';

import { useTitle } from '@/hooks';

import { useUserInfo } from '../users/hooks';

import { ContactDetails, SupportResources } from './components';

export const Support = () => {
  useTitle('Support');

  const { first_name } = useUserInfo();

  return (
    <Box px={4} py={3}>
      <Typography fontSize={18} fontWeight={500} pb={4}>
        How can we help you, {first_name}?
      </Typography>
      <Stack spacing={3}>
        <SupportResources />
        <ContactDetails />
      </Stack>
    </Box>
  );
};
